$(function () {
    //header
    $('.icon-search').show();

    function desktopMenu () {
        $('header .dropdown-toggle').on('click', function (e) {
            $('.dropdown-menu').removeClass('show');
            $(this).parent().find('.dropdown-menu').addClass('show');

            $('.bg-light').addClass('show');
            e.stopPropagation();
        });

        $('.navbar.navbar-light .nav-link').hover(function () {
            $('.bg-light').addClass('show');
            $('.navbar.navbar-light .nav-link').removeClass('show');
            $('.navbar.navbar-light .dropdown-menu').removeClass('show');

            $(this).addClass('show');
            $(this).parent('.dropdown').find('.dropdown-menu').addClass('show');
        });

        $('.header-content, #main-content').hover(function () {
            $('.bg-light').removeClass('show');
            $('.navbar.navbar-light .nav-link').removeClass('show');
            $('.navbar.navbar-light .dropdown-menu').removeClass('show');
        });
    }

    $('.navbar-toggler').on('click', function () {
        $('.bg-light').toggleClass('show');
        $('.icon-search').toggle();
        $('body').toggleClass('menu-open');
        $('.content-form').addClass('d-none');
    });

    $('.a-search').on('click', function () {
        $('.content-form').toggleClass('d-none');
    });

    $('.a-search-close').on('click', function () {
        $('.content-form').addClass('d-none');
    });

    var lastScrollTop = 0;

    function bodyScroll () {
        var st = $(this).scrollTop();

        if (st > 1) {
            $('body').addClass('scroll');
        } else {
            $('body').removeClass('scroll');
            $('.bg-light').removeClass('show');
        }

        if (st + $(window).height() == $(document).height()) {
            $('body').removeClass('scrollup');
        }

        if (st > lastScrollTop) {
            $('body').removeClass('scrollup');
        } else {
            $('body').addClass('scrollup');
        }

        lastScrollTop = st;
    }

    bodyScroll();

    $(window).scroll(function (event) {
        bodyScroll();
        var win = $(window);
        if (win.width() >= 992) {
            $('.navbar.navbar-light .dropdown-menu').removeClass('show');
            $('.navbar.navbar-light .nav-link.dropdown-toggle').removeClass('show');
        }
    });

    //desktopMenu
    var win = $(window);
    if (win.width() >= 992) {
        desktopMenu();
    }

    $(window).on('resize', function () {
        var win = $(this);
        if (win.width() >= 992) {
            desktopMenu();
        }
    });

    //END desktopMenu
    $('.dropdown-menu a').on('click', function () {
        $('.navbar-collapse').collapse('hide');
        $('body').removeClass('menu-open');
    });
});
